module.exports = __webpack_public_path__ + "static/img/mdsing.04b5047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mdsing.png
// module id = 4IgY
// module chunks = 4